import { getUserFeedbackApi } from "@services/myUserForm/getUserFeebackApi";
import {
  GET_MY_USER_FEEDBACK_SUCCESS,
  GET_MY_USER_FEEDBACK_FAIL,
} from "../constants/action-types";
import { setAlert } from "./alert-action";
import { sessionExpireTimeout } from "./utility-actions";

export const getMyUserFeedback = () => async (dispatch) => {
  const response = await getUserFeedbackApi();
  if (response?.status === 200) {
    dispatch({
      type: GET_MY_USER_FEEDBACK_SUCCESS,
      payload: response?.data?.records,
    });
  } else if (response?.error === "ERR_NETWORK") {
    sessionExpireTimeout(dispatch);
  } else {
    dispatch({
      type: GET_MY_USER_FEEDBACK_FAIL,
    });
    dispatch(setAlert(response?.error, "error"));
  }
};
